import { useEffect, useState } from 'react';
import _uniq from 'lodash/uniq';

import { get, isEmpty } from 'ravenjs/utils/lodash';

import { CASE_DETAILS } from 'constants/tickets';

export function useCaseHistory({ caseId, fetchCaseHistory, fetchCaseTasks, fetchUsers }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchCaseHistoryData() {
            try {
                setLoading(true);
                const response = await fetchCaseHistory({ id: caseId });
                const responseData = get(response, 'data', []);
                const hasTasksTransition =
                    responseData.findIndex(
                        ({ attributes }) =>
                            attributes?.event ===
                                CASE_DETAILS.CASE_LOG.HISTORY.HISTORY_EVENTS.TASK_COMPLETE ||
                            attributes?.event ===
                                CASE_DETAILS.CASE_LOG.HISTORY.HISTORY_EVENTS.TASK_CANCEL
                    ) !== -1;

                const usersMap = {};
                let tasks = [];
                if (hasTasksTransition) {
                    const caseTasksResponse = await fetchCaseTasks({ caseId });
                    tasks = get(caseTasksResponse, 'data', []);
                    const taskUserIds = [];
                    tasks.forEach(task => {
                        const assignerId = get(task, 'attributes.assigner_id');
                        if (assignerId) {
                            taskUserIds.push(assignerId);
                        }
                    });
                    const usersResponse = await fetchUsers({ userId: _uniq(taskUserIds) });
                    const users = get(usersResponse, 'users', []);
                    users.forEach(user => (usersMap[user.userId] = user));
                }

                const formattedResponse = responseData
                    .map(({ attributes, ...rest }) => {
                        const { event } = attributes;
                        if (
                            event === CASE_DETAILS.CASE_LOG.HISTORY.HISTORY_EVENTS.TASK_COMPLETE ||
                            event === CASE_DETAILS.CASE_LOG.HISTORY.HISTORY_EVENTS.TASK_CANCEL
                        ) {
                            const { id } = rest;
                            const taskId = id?.split('_')?.[1];
                            const foundTask = tasks.find(({ id }) => id === taskId);
                            let assignerFullName = '';

                            if (!isEmpty(foundTask)) {
                                const { attributes } = foundTask;
                                const { assigner_id } = attributes;
                                assignerFullName = usersMap[assigner_id]?.fullName;
                            }

                            return {
                                ...attributes,
                                ...rest,
                                assignerFullName,
                            };
                        } else {
                            return {
                                ...attributes,
                                ...rest,
                            };
                        }
                    })
                    .sort((a, b) => new Date(b.occurred_at) - new Date(a.occurred_at));
                setData(formattedResponse);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        }
        fetchCaseHistoryData();
    }, [fetchCaseHistory, caseId, fetchCaseTasks, fetchUsers]);

    return { data, error, loading };
}
